<template lang="html">
  <b-navbar toggleable="lg" type="dark" variant="secondary">
    <b-navbar-brand :to="{ name: 'shows' }">Soundslides</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" />

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :to="{ name: 'shows' }">
          Shows 📙
        </b-nav-item>
        <b-nav-item
          v-if="$store.state.displayLegacyVideoNav"
          :to="{ name: 'converter' }"
        >
          Video Conversion
        </b-nav-item>
        <b-nav-item
          v-if="$store.state.user_doc.display_group_admin"
          :to="{ name: 'groups' }"
        >
          Groups 📓
        </b-nav-item>
        <b-nav-item href="https://forum.soundslides.org">Forum</b-nav-item>
        <b-nav-item href="https://help.soundslides.com">Help</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!--
        If you're going to add a search bar, do it here.
        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>
      -->

        <b-nav-form v-if="authorized && $store.getters.is_trial">
          <b-button
            size="sm"
            variant="primary"
            class="my-2 ml-3 my-sm-0"
            :to="{ name: 'upgrade_view', params: { plan_name: 'basic' } }"
          >
            Upgrade
          </b-button>
        </b-nav-form>

        <b-navbar-nav v-if="!authorized" right>
          <b-nav-item
            :to="{ name: 'account' }"
            size="sm"
            variant="primary"
            class="ml-3"
          >
            Login
          </b-nav-item>
        </b-navbar-nav>

        <b-nav-form v-if="!authorized">
          <b-button
            size="sm"
            variant="primary"
            class="my-2 ml-3 my-sm-0"
            :to="{ name: 'trial' }"
          >
            Sign up
          </b-button>
        </b-nav-form>

        <b-navbar-nav v-if="authorized" right>
          <b-nav-item :to="{ name: 'account' }" class="ml-3">
            Account
          </b-nav-item>
          <b-nav-item @click="$store.dispatch('sign_out')">Logout</b-nav-item>
        </b-navbar-nav>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    authorized() {
      return this.$store.state.authorized;
    },
    is_trial() {
      return this.$store.getters.is_trial;
    }
  }
};
</script>

<style lang="scss" scoped></style>
